var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullStarGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02737 0.869035C7.18242 0.419921 7.81758 0.419921 7.97263 0.869035L9.29208 4.69103C9.36168 4.89261 9.55146 5.02786 9.76471 5.02786H13.967C14.4586 5.02786 14.6551 5.66307 14.2492 5.9406L10.9027 8.22895C10.7167 8.35611 10.6388 8.59191 10.7123 8.80485L12.0027 12.5426C12.1599 12.998 11.6455 13.3904 11.2478 13.1185L7.78223 10.7487C7.61207 10.6324 7.38793 10.6324 7.21777 10.7487L3.7522 13.1185C3.35453 13.3904 2.84013 12.998 2.99734 12.5426L4.28771 8.80485C4.36123 8.59191 4.28326 8.35611 4.09731 8.22895L0.750804 5.9406C0.34495 5.66307 0.541363 5.02786 1.03303 5.02786H5.23529C5.44854 5.02786 5.63833 4.89261 5.70792 4.69103L7.02737 0.869035Z",
    fill: "#82DD55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStarGreen);
export default __webpack_public_path__ + "static/media/full_star_green.7f2bee9fdf610ab14be43d6046d4bd25.svg";
export { ForwardRef as ReactComponent };